import React, { useState } from 'react';
import { FriendsList } from '../../../components/social/FriendsList';
import { FriendRequest } from '../../../components/social/FriendRequest';

export default function AmigosPage() {
  const [activeTab, setActiveTab] = useState<'friends' | 'requests' | 'search'>('friends');
  const [searchTerm, setSearchTerm] = useState('');

  const tabs = [
    { id: 'friends', label: 'Meus Amigos', icon: 'ri-user-heart-line' },
    { id: 'requests', label: 'Solicitações', icon: 'ri-user-add-line', badge: 3 },
    { id: 'search', label: 'Buscar Pessoas', icon: 'ri-search-line' }
  ];

  const handleViewProfile = (friendId: string) => {
    console.log('Ver perfil:', friendId);
    // Implementar navegação para perfil
  };

  const handleRemoveFriend = (friendId: string) => {
    console.log('Remover amigo:', friendId);
    // Implementar remoção
  };

  const handleSendRequest = (userId: string) => {
    console.log('Enviar solicitação:', userId);
    // Implementar envio de solicitação
  };

  // Mock de usuários para busca
  const searchResults = [
    {
      id: '1',
      name: 'Lucas Martins',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20avatar%20portrait%20simple%20background%20friendly%20smile&width=100&height=100&seq=search-001&orientation=squarish',
      level: 17,
      mutualFriends: 4,
      isFriend: false
    },
    {
      id: '2',
      name: 'Beatriz Rocha',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20avatar%20portrait%20simple%20background%20warm%20smile&width=100&height=100&seq=search-002&orientation=squarish',
      level: 19,
      mutualFriends: 6,
      isFriend: false
    },
    {
      id: '3',
      name: 'Rafael Cardoso',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20avatar%20portrait%20simple%20background%20confident&width=100&height=100&seq=search-003&orientation=squarish',
      level: 15,
      mutualFriends: 2,
      isFriend: false
    }
  ];

  const filteredResults = searchResults.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Amigos & Conexões
        </h1>
        <p className="text-gray-600">
          Conecte-se com outros participantes, compartilhe conquistas e cresçam juntos!
        </p>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-2">
        <div className="flex gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id as any)}
              className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-medium transition-all ${
                activeTab === tab.id
                  ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <i className={`${tab.icon} text-lg`}></i>
              {tab.label}
              {tab.badge && (
                <span className="ml-1 px-2 py-0.5 bg-red-500 text-white text-xs rounded-full font-bold">
                  {tab.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Conteúdo das Tabs */}
      {activeTab === 'friends' && (
        <FriendsList
          onViewProfile={handleViewProfile}
          onRemoveFriend={handleRemoveFriend}
        />
      )}

      {activeTab === 'requests' && (
        <FriendRequest
          onAccept={(id) => console.log('Aceitar:', id)}
          onReject={(id) => console.log('Recusar:', id)}
        />
      )}

      {activeTab === 'search' && (
        <div className="space-y-6">
          {/* Busca */}
          <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
            <div className="relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Buscar por nome ou email..."
                className="w-full pl-14 pr-4 py-4 bg-gray-50 border-2 border-gray-200 rounded-lg focus:border-teal-500 focus:ring-2 focus:ring-teal-200 transition-all text-lg"
              />
            </div>
          </div>

          {/* Resultados */}
          {searchTerm && (
            <div className="grid gap-4">
              {filteredResults.map((user) => (
                <div
                  key={user.id}
                  className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-all"
                >
                  <div className="flex items-center gap-4">
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="w-16 h-16 rounded-full object-cover border-2 border-teal-500"
                    />
                    <div className="flex-1">
                      <h3 className="font-bold text-gray-800 text-lg mb-1">
                        {user.name}
                      </h3>
                      <div className="flex items-center gap-3 text-sm text-gray-600">
                        <span>
                          <i className="ri-vip-crown-line text-teal-500 mr-1"></i>
                          Nível {user.level}
                        </span>
                        <span>
                          <i className="ri-group-line text-purple-500 mr-1"></i>
                          {user.mutualFriends} amigos em comum
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={() => handleSendRequest(user.id)}
                      className="px-6 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-lg font-medium hover:from-teal-600 hover:to-cyan-600 transition-all whitespace-nowrap"
                    >
                      <i className="ri-user-add-line mr-2"></i>
                      Adicionar
                    </button>
                  </div>
                </div>
              ))}

              {filteredResults.length === 0 && (
                <div className="bg-white rounded-xl shadow-md border border-gray-200 p-12 text-center">
                  <i className="ri-user-search-line text-6xl text-gray-300 mb-4"></i>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    Nenhum resultado encontrado
                  </h3>
                  <p className="text-gray-600">
                    Tente buscar por outro nome ou email.
                  </p>
                </div>
              )}
            </div>
          )}

          {!searchTerm && (
            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-12 text-center">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                Busque por novos amigos
              </h3>
              <p className="text-gray-600">
                Digite um nome ou email para encontrar outros participantes.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
